define(["../core/l10n", "../core/dfn-map", "hyperhtml", "../core/ui"], function (_l10n, _dfnMap, _hyperhtml, _ui) {
  "use strict";

  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["", ""]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["\n        <li>\n          <a href=\"", "\">\n            ", "\n          </a>\n        </li>\n      "]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const button = _ui.ui.addCommand(_l10n.l10n[_l10n.lang].definition_list, show, "Ctrl+Shift+Alt+D", "📔");

  const ul = document.createElement("ul");
  ul.classList.add("respec-dfn-list");

  const render = _hyperhtml.default.bind(ul);

  ul.addEventListener("click", ev => {
    _ui.ui.closeModal();

    ev.stopPropagation();
  });

  function show() {
    const definitionLinks = Object.entries(_dfnMap.definitionMap).sort(([keyA], [keyB]) => keyA.localeCompare(keyB)).map(([, [dfn]]) => {
      return _hyperhtml.default.wire(dfn, ":li>a")(_templateObject(), "#".concat(dfn.id), dfn.textContent);
    });
    render(_templateObject2(), definitionLinks);

    _ui.ui.freshModal(_l10n.l10n[_l10n.lang].list_of_definitions, ul, button);
  }
});
//# sourceMappingURL=dfn-list.js.map